import moment from "moment"

export const formatDate = ( string, split='-' ) => {
  let newDate 
  if(string) {
    newDate = moment(string).format(`YYYY${split}MM${split}DD`)
  } else {
    newDate = moment(new Date()).format(`YYYY${split}MM${split}DD`)
    return 
  //   const tempDate = new Date()
  //  return moment(tempDate).format('YYYY-MM-DD') 
  }
  return newDate
}